'use client';

import { useSearchParams } from 'next/navigation';
import LienHePage from '../../page/LienHePage/LienHePage';
import KhaoSat from '../../components/KhaoSat/KhaoSat';
import MultimediaInterface from '../../components/MultipleMedia/MultimediaInterface';
import isEmpty from 'lodash/isEmpty';
import { useTranslations } from 'next-intl';
import HoiDapPage from '@/page/HoiDapPage/HoiDapPage';
import SoDoCongPage from '@/page/SoDoCongPage/SoDoCongPage';
import DonThuPage from '@/page/DonThuPage/DonThuPage';
import VanBanPage from '@/page/VanBanPage/VanBanPage';
import ChiTietBaiVietPage from '@/page/ChiTietBaiVietPage/ChiTietBaiVietPage';
import TinTongHopPage from '@/page/TinTongHopPage/TinTongHopPage';
import DuThaoPage from '@/page/DuThaoPage/DuThaoPage';
import LichPage from '@/page/LichPage/LichPage';
import ChuyenMucPage from '@/page/ChuyenMucPage/ChuyenMucPage';
import KienNghiCuTriPage from '@/page/KienNghiCuTriPage/KienNghiCuTriPage';

export default function PageSlug({ menuSlug, ...props }) {
  const searchParams = useSearchParams();

  const text = searchParams.get('text');
  const tag = searchParams.get('tag');
  const date = searchParams.get('date');
  const t = useTranslations('');

  const renderContent = () => {
    if (!isEmpty(text) || !isEmpty(tag) || !isEmpty(date)) {
      return <ChuyenMucPage titlePage={`Kết quả tìm kiếm của: ${text || tag}`} {...props} />;
    }

    if (!menuSlug) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[500px] text-center px-4 ">
          <div className="relative">
            <div
              className="absolute -top-10 -left-10 w-20 h-20 bg-gradient-to-br 
            from-red-100 to-pink-100 rounded-full opacity-60 animate-pulse"></div>
            <div
              className="absolute -bottom-10 -right-10 w-16 h-16 bg-gradient-to-br 
            from-purple-100 to-blue-100 rounded-full opacity-60 animate-pulse delay-500"></div>

            <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md mx-auto">
              <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500 mb-4">404</div>

              <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-red-400 to-pink-500 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 
                    012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>

              <p className="text-2xl font-bold text-gray-800 mb-3">{t('home.erorrNotFound')}</p>

              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={() => window.history.back()}
                  className="px-6 py-3 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 
                  hover:to-pink-700 text-white rounded-lg font-medium transition-all duration-200 
                  transform hover:scale-105 shadow-lg hover:shadow-xl cursor-pointer">
                  ← {t('home.back')}
                </button>
                <button
                  onClick={() => (window.location.href = '/')}
                  className="px-6 py-3 bg-white border-2 border-gray-200 hover:border-gray-300 
                  text-gray-700 hover:text-gray-900 rounded-lg font-medium transition-all 
                  duration-200 transform hover:scale-105 hover:shadow-md cursor-pointer">
                  🏠 {t('home.hometitle')}
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
    // Render nội dung theo type của menu
    if (menuSlug?.type === 'qldt') {
      return <DonThuPage {...props} />;
    }
    if (menuSlug?.type === 'table') {
      return <VanBanPage {...props} />;
    }
    if (menuSlug?.type === 'ykct') {
      return <KienNghiCuTriPage {...props} />;
    }
    if (menuSlug?.type === 'contact') {
      return <LienHePage {...props} />;
    }
    if (menuSlug?.type === 'hoi_dap') {
      return <HoiDapPage {...props} />;
    }
    if (menuSlug?.type === 'khao_sat') {
      return <KhaoSat {...props} />; // todo
    }
    if (menuSlug?.type === 'single') {
      return <ChiTietBaiVietPage {...props} />; // todo
    }
    if (menuSlug?.type === 'library') {
      return <MultimediaInterface titlePage={menuSlug?.name ?? ''} />; // todo
    }
    if (menuSlug?.type === 'collection') {
      return <ChuyenMucPage {...props} />;
    }
    if (menuSlug?.type === 'schedule') {
      return <LichPage {...props} />;
    }
    if (menuSlug?.type === 'diagram') {
      return <SoDoCongPage {...props} />;
    }
    if (menuSlug?.type === 'postsRss') {
      return <TinTongHopPage {...props} />;
    }
    if (menuSlug?.type === 'advice') {
      return <DuThaoPage {...props} />;
    }

    return (
      <div className="flex flex-col items-center justify-center min-h-[500px] text-center px-4">
        <div className="relative">
          <div
            className="absolute -top-10 -left-10 w-20 h-20 bg-gradient-to-br 
          from-blue-100 to-purple-100 rounded-full opacity-60 animate-pulse"></div>
          <div
            className="absolute -bottom-10 -right-10 w-16 h-16 bg-gradient-to-br 
          from-pink-100 to-orange-100 rounded-full opacity-60 animate-pulse delay-1000"></div>

          <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-gray-100 p-8 max-w-md mx-auto">
            <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 
                  4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                />
              </svg>
            </div>

            <p className="text-2xl font-bold text-gray-800 mb-3">{t('home.erorrNotFound')}</p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 
                hover:to-blue-700 text-white rounded-lg font-medium transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl">
                ← {t('home.back')}
              </button>
              <button
                onClick={() => (window.location.href = '/')}
                className="px-6 py-3 bg-white border-2 border-gray-200 hover:border-gray-300 text-gray-700 
                hover:text-gray-900 rounded-lg font-medium transition-all duration-200 transform hover:scale-105 hover:shadow-md">
                🏠 {t('home.hometitle')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`${menuSlug?.type === 'library' ? 'mx-auto px-2 md:px-4' : 'container mx-auto px-2 md:px-4 mt-2  bg-white shadow-sm py-2'}`}>
      <div className="flex flex-col gap-2 ">{renderContent()}</div>
    </div>
  );
}
